import * as React from 'react';
import { Input, Segment } from 'semantic-ui-react';
import axios, { AxiosRequestConfig, AxiosResponse } from 'axios';
import OAuth, { OAuthClientStatus } from '../api';

class State {
    data: any;
}

interface Props {

}

export default class CliView extends React.Component<Props, State> {

    private readonly cmdInput: React.RefObject<any>;
    private updateCount = 0;
    private timer: any;

    constructor(props: any) {
        super(props);

        this.cmdInput = React.createRef();
    }

    componentWillMount() {
        this.setState({
            data: ''
        });
    }

    componentDidMount() {
        this.cmdInput.current.focus();
    }

    sendCommand(e: any, host: any, secureHost: any) {
        let command = e.target.value;
        let waitTime =  0;
        if (e.key === 'Enter') {
            if (this.timer) {
                // stop existing timer
                clearInterval(this.timer);
                this.timer = null;
            }
            this.updateCount = 0;
            if (command.includes('@')) {
                // check for a number before the @.
                let index = command.indexOf('@');
                if (index > 0) {
                    // if number before the @, repeat command once per number of specified seconds.
                    waitTime = command.slice(0, index);
                    waitTime = waitTime * 1000;
                } else {
                    // if nothing before the @, repeat command once per second
                    waitTime = 1000;
                }
                command = command.slice(index + 1);
                if (!this.timer) {
                    this.timer = setInterval(() => {
                        this.fetchData(command, host, secureHost, false);
                    },                       waitTime);
                }
            } else {
                this.fetchData(e.target.value, host, secureHost, false); // Sending 10 dummy requests after each query. Copying this behavior from old ui. Couldn't get any explanation for this.
            }
        }
    }

    fetchData(input: any, host: any, secureHost: any, onlyDummyRequest: boolean) {
        let url = 'http://' + host + '/api/clidata2.html?' + ((!onlyDummyRequest) ? 'cliInput=' + input : '' ) + '&dummy=' + Date.now();
        if (secureHost) {
            url = 'https://' + host + '/api/clidata2.html?' + ((!onlyDummyRequest) ? 'cliInput=' + input : '') + '&dummy=' + Date.now();
        }
        axios.get(url)
            .then((resp: AxiosResponse) => {
                if (resp.data !== undefined) {
                    if (!onlyDummyRequest) {                // The dummy request sends blank response. Don't want to set that to data. Not sure why these dummy requests need to be sent every time.
                        let str = resp.data;
                        while (str.charAt(0) !== '>') {
                            str = str.substr(1);
                        }
                        this.setState({
                            data: str
                        });
                    }
                    if (this.updateCount < 10) {
                        this.fetchData(input, host, secureHost, true);
                    }
                    this.updateCount++;
                } else {
                    throw resp;
                }
            })
            .catch( (err: AxiosRequestConfig) => {
                // tslint:disable-next-line:no-console
                console.log('expected cli response, got', err);
            });
    }
    render() {
        return (
            <div className="view-content" id="cli">
                <div className="pageTitle">
                    <div className="page-title-block">
                        <div className="iq-temp-key-val">
                            <div className="iq-temp-val page-title-text">Command Line Interface</div>
                        </div>
                    </div>
                </div>
                <div className="filterPanel align-center">
                    <OAuth.Context>{ (oauth: OAuthClientStatus) => (
                        <Input
                            style={{ minWidth: 350, maxWidth: 750 }}
                            onKeyPress={(e: any) => this.sendCommand(e, oauth.host, oauth.secureHost)}
                            ref={this.cmdInput}
                        />
                    )}
                    </OAuth.Context>
                </div>
                <div className="view-clientarea">
                    <Segment className="view-content config-view flow sysConfig-right-panel vertical-flex-parent">
                        <div className="response-text vertical-flex-main"> <pre>{this.state.data}</pre></div>
                    </Segment>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/views/cli.tsx